// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 532) return "static/css/532.78e26e9b.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}